import { useCallback } from 'react';

import { globalState } from '../models';

export default function useHighlightResizeState() {
  return globalState(useCallback((state) => state.highlightResizeState, []));
}
